import {txt, type Texto} from '../i18n/idioma';

// Nota de cada campo de Doré (Daniel, 14/10/2026): qué es y cómo se llena.
// La usan la tabla del seguimiento (al pasar el cursor por el título) y la
// ficha de la exportación. "En el archivo" = la columna del Seguimiento.xlsx.
export const AYUDA_DORE: Record<string, Texto> = {
  codigo: txt(
    'Código de la exportación: la venta de la intermediaria al comprador final y su número (por ejemplo, XXXYYY-12). En el archivo: EXPORT N. No se repite.',
    'Export code: the intermediary’s sale to the final buyer and its number (for example, XXXYYY-12). In the file: EXPORT N. It is unique.',
  ),
  etapa: txt(
    'En qué va la exportación. Sale del estado del archivo; si no tiene, la calcula la app: sin salida = Documentos, salió y no ha llegado = En tránsito, llegó sin primer pago = Seguimiento del pago, sin resultado del ensayo = Ensayo, con liquidación pendiente = Liquidación.',
    'Where the export stands. It comes from the status in the file; without one the app works it out: not shipped = Documents, shipped and not arrived = In transit, arrived without first payment = Payment follow-up, no assay result = Assay, pending settlement = Settlement.',
  ),
  faltan: txt(
    'Lo que le falta a una exportación que ya salió: primer pago del comprador, pago al proveedor o resultado del ensayo. Lo calcula la app; se quita solo cuando se registra el dato.',
    'What a shipped export is missing: first payment from the buyer, payment to the supplier or assay result. The app works it out; it goes away when the data is recorded.',
  ),
  estadoArchivo: txt(
    'El estado tal como está en el archivo (Finalizada, Pago Liquidación…). En el archivo: Status.',
    'The status as written in the file (Finalizada, Pago Liquidación…). In the file: Status.',
  ),
  intermediaria: txt(
    'Empresa que le compra al proveedor y le vende al comprador final; casi siempre una del grupo. En una venta directa es el mismo comprador. En el archivo: Buyer.',
    'Company that buys from the supplier and sells to the final buyer; almost always a group company. In a direct sale it is the buyer itself. In the file: Buyer.',
  ),
  compradorFinal: txt(
    'Quien recibe el doré y le paga a la intermediaria. En el archivo: Final Buyer.',
    'Who receives the doré and pays the intermediary. In the file: Final Buyer.',
  ),
  referencia: txt(
    'Código corto del comprador final. En el archivo: REF.',
    'Short code of the final buyer. In the file: REF.',
  ),
  pais: txt(
    'País de destino del doré. En el archivo: Destination Country.',
    'Destination country. In the file: Destination Country.',
  ),
  proveedor: txt(
    'Quien produce y vende el doré a la intermediaria. "X DIRECT" se toma como el mismo proveedor X. En el archivo: SUPPLIER.',
    'Who produces and sells the doré to the intermediary. "X DIRECT" is taken as the same supplier X. In the file: SUPPLIER.',
  ),
  compra: txt(
    'Número de la compra en el sistema contable (NEO). En el archivo: PURCHASE N.',
    'Purchase number in the accounting system (NEO). In the file: PURCHASE N.',
  ),
  ventaDelProveedor: txt(
    'Código con el que el proveedor le vende a la intermediaria (por ejemplo, XXYYY-165). Sale en los documentos del proveedor y en el nombre de la carpeta. No está en el archivo: se escribe en la app.',
    'Code under which the supplier sells to the intermediary (for example, XXYYY-165). It appears on the supplier’s documents and in the folder name. Not in the file: it is entered in the app.',
  ),
  facturaProveedor: txt(
    'Factura del proveedor a la intermediaria. En el archivo: SUPPLIER INVOICE N.',
    'Supplier’s invoice to the intermediary. In the file: SUPPLIER INVOICE N.',
  ),
  exportacionProveedor: txt(
    'Número de exportación del proveedor ante aduana. En el archivo: SUPPLIER EXP. #.',
    'Supplier’s customs export number. In the file: SUPPLIER EXP. #.',
  ),
  tipoDeMaterial: txt(
    'Origen del material en las exportaciones antiguas (barequeo, compras…). En el archivo: TYPE.',
    'Origin of the material in older exports (small-scale mining, purchases…). In the file: TYPE.',
  ),
  barras: txt(
    'Cantidad de barras doré. En el archivo: Dore Bars QUANTITY.',
    'Number of doré bars. In the file: Dore Bars QUANTITY.',
  ),
  barrasDePlata: txt(
    'Cantidad de barras de plata. En el archivo: Silver Bars.',
    'Number of silver bars. In the file: Silver Bars.',
  ),
  brutoG: txt(
    'Peso bruto de las barras en gramos. En el archivo: GROSS WEIGHT (GRS).',
    'Gross weight of the bars in grams. In the file: GROSS WEIGHT (GRS).',
  ),
  oroG: txt(
    'Gramos de oro de las barras. En el archivo: GRAMS AU.',
    'Grams of gold in the bars. In the file: GRAMS AU.',
  ),
  oroOz: txt(
    'Onzas troy de oro. La calcula la app: gramos ÷ 31,1034768.',
    'Troy ounces of gold. The app works it out: grams ÷ 31.1034768.',
  ),
  plataG: txt(
    'Gramos de plata de las barras. En el archivo: GRAMS AG.',
    'Grams of silver in the bars. In the file: GRAMS AG.',
  ),
  plataOz: txt(
    'Onzas troy de plata. La calcula la app: gramos ÷ 31,1034768.',
    'Troy ounces of silver. The app works it out: grams ÷ 31.1034768.',
  ),
  fechaDocumentos: txt(
    'Fecha de los documentos de la exportación. En el archivo: EXPORT DOC DATE.',
    'Date of the export documents. In the file: EXPORT DOC DATE.',
  ),
  fechaExportacion: txt(
    'Fecha en que salió el vuelo. En el archivo: EXPORT DATE.',
    'Flight date. In the file: EXPORT DATE.',
  ),
  llegada: txt(
    'Llegada al destino. Con ≈ es estimada: el archivo la calculaba con fórmula (salida + 4 días). En el archivo: ARRIVAL DATE.',
    'Arrival at destination. With ≈ it is estimated: the file calculated it with a formula (departure + 4 days). In the file: ARRIVAL DATE.',
  ),
  llegadaRefineria: txt(
    'Llegada a la refinería del comprador. Con ≈ es estimada (llegada + 0 a 2 días en el archivo). En el archivo: ARRIVAL TO REFINERY.',
    'Arrival at the buyer’s refinery. With ≈ it is estimated (arrival + 0 to 2 days in the file). In the file: ARRIVAL TO REFINERY.',
  ),
  servicio: txt(
    'Servicio de transporte: DTD (puerta a puerta) o DTA (puerta a aeropuerto). En el archivo: Transport Service.',
    'Transport service: DTD (door to door) or DTA (door to airport). In the file: Transport Service.',
  ),
  transportadora: txt(
    'Empresa que transporta el doré. En el archivo: TRANSPORT COMPANY.',
    'Company that carries the doré. In the file: TRANSPORT COMPANY.',
  ),
  mawb: txt(
    'Guía aérea master del primer tramo (desde Colombia). En el archivo: MAWB.',
    'Master air waybill of the first leg (from Colombia). In the file: MAWB.',
  ),
  hawb: txt(
    'Guía aérea hija de la transportadora. En el archivo: HAWB.',
    'House air waybill of the carrier. In the file: HAWB.',
  ),
  mawbConexion: txt(
    'Guía aérea master del tramo de conexión hacia el destino. En el archivo: MAWBCONECTION.',
    'Master air waybill of the connecting leg to the destination. In the file: MAWBCONECTION.',
  ),
  radicadoVuce: txt(
    'Número del trámite en VUCE. En el archivo: RADICADO VUCE.',
    'VUCE filing number. In the file: RADICADO VUCE.',
  ),
  aprobacionVuce: txt(
    'Fecha en que VUCE aprobó el trámite. En el archivo: VUCE APPROVAL.',
    'Date VUCE approved the filing. In the file: VUCE APPROVAL.',
  ),
  valorProveedorUsd: txt(
    'Valor de la factura del proveedor en dólares. En el archivo: TOTAL AMOUNT SUPPLIER.',
    'Supplier invoice value in dollars. In the file: TOTAL AMOUNT SUPPLIER.',
  ),
  valorVentaUsd: txt(
    'Valor de la venta de la intermediaria al comprador final en dólares. En el archivo: TOTAL AMOUNT EXPORTER SVI/CI.',
    'Value of the intermediary’s sale to the final buyer in dollars. In the file: TOTAL AMOUNT EXPORTER SVI/CI.',
  ),
  primerPagoUsd: txt(
    'Primer pago (anticipo) del comprador final a la intermediaria. En el archivo: Final Buyer to Intermediary First payment Value.',
    'First payment (advance) from the final buyer to the intermediary. In the file: Final Buyer to Intermediary First payment Value.',
  ),
  primerPagoEl: txt(
    'Fecha del primer pago. Con ≈ es estimada (el archivo la calculaba como salida + 11 días). En el archivo: FIRST PAYMENT DATE.',
    'Date of the first payment. With ≈ it is estimated (the file calculated it as departure + 11 days). In the file: FIRST PAYMENT DATE.',
  ),
  motivoDeDemora: txt(
    'Por qué se demoró el pago, de la lista del archivo (comprador sin fondos, transporte, festivo…). En el archivo: Delay variable.',
    'Why the payment was late, from the file’s list (buyer without funds, transport, holiday…). In the file: Delay variable.',
  ),
  saldoUsd: txt(
    'Segundo pago (el saldo) del comprador final a la intermediaria. En el archivo: Final Buyer to Intermediary Second Payment done.',
    'Second payment (the balance) from the final buyer to the intermediary. In the file: Final Buyer to Intermediary Second Payment done.',
  ),
  pagoProveedorUsd: txt(
    'Lo que la intermediaria le pagó al proveedor. En el archivo: Payment from Intermediary to Exporter.',
    'What the intermediary paid the supplier. In the file: Payment from Intermediary to Exporter.',
  ),
  pagoProveedorEl: txt(
    'Fecha del pago al proveedor. Con ≈ es estimada (calculada con fórmula en el archivo). En el archivo: Payment Date Intermediary to Exporter.',
    'Date of the payment to the supplier. With ≈ it is estimated (a formula in the file). In the file: Payment Date Intermediary to Exporter.',
  ),
  resultadoEnsayo: txt(
    'Resultado del ensayo (assay) del comprador: Aprobado o Reanálisis. En el archivo: REANALYSIS ESTIMATED DATE (ahí se escribe el resultado).',
    'Result of the buyer’s assay: Approved or Re-assay. In the file: REANALYSIS ESTIMATED DATE (the result is written there).',
  ),
  liquidacionCompradorUsd: txt(
    'Valor final que liquida el comprador final después del ensayo. En el archivo: Liquidation from Final Buyer.',
    'Final value the final buyer settles after the assay. In the file: Liquidation from Final Buyer.',
  ),
  comentarios: txt(
    'Notas libres de la exportación. En el archivo: COMMENTS.',
    'Free notes about the export. In the file: COMMENTS.',
  ),

  // Solo en la ficha: ensayo y liquidaciones.
  ensayoOro: txt(
    'Onzas y valor del oro según el ensayo del comprador. En el archivo: AU Oz Assay y AU Assay Value.',
    'Ounces and value of the gold per the buyer’s assay. In the file: AU Oz Assay and AU Assay Value.',
  ),
  ensayoPlata: txt(
    'Onzas y valor de la plata según el ensayo del comprador. En el archivo: AG Oz Assay y AG Assay Value.',
    'Ounces and value of the silver per the buyer’s assay. In the file: AG Oz Assay and AG Assay Value.',
  ),
  cargos: txt(
    'Cargos de refinación y transporte que descuenta la liquidación. En el archivo: Liquidation Fee/charges.',
    'Refining and transport charges deducted in the settlement. In the file: Liquidation Fee/charges.',
  ),
  informe: txt(
    'Fecha del informe del ensayo, o "Pendiente" si todavía no llega. En el archivo: ASSAY REPORT DATE.',
    'Date of the assay report, or "Pending" if it has not arrived. In the file: ASSAY REPORT DATE.',
  ),
  reanalisis: txt(
    'Si se pidió un reanálisis. En el archivo: REANALYSIS SI / NO.',
    'Whether a re-assay was requested. In the file: REANALYSIS SI / NO.',
  ),
  respuestaProveedor: txt(
    'Cuándo respondió el proveedor (aprueba o pide reanálisis). En el archivo: SUPPLIERS ANSWER DATE.',
    'When the supplier answered (approves or asks for a re-assay). In the file: SUPPLIERS ANSWER DATE.',
  ),
  respuestaRefineria: txt(
    'Cuándo respondió la refinería. En el archivo: REFINERY ANSWER DATE.',
    'When the refinery answered. In the file: REFINERY ANSWER DATE.',
  ),
  finReanalisis: txt(
    'Fecha en que terminó el reanálisis. En el archivo: REANALYSIS FINAL DATE.',
    'Date the re-assay ended. In the file: REANALYSIS FINAL DATE.',
  ),
  liquidacionValor: txt(
    'Valor de esta liquidación. Comprador: Liquidation from Final Buyer. Proveedor: Liquidation Value Intermediary/Exporter.',
    'Value of this settlement. Buyer: Liquidation from Final Buyer. Supplier: Liquidation Value Intermediary/Exporter.',
  ),
  pagableOro: txt(
    'Porcentaje del oro que paga el comprador según su acuerdo. En el archivo: %DG AU Payability.',
    'Percentage of the gold the buyer pays under its agreement. In the file: %DG AU Payability.',
  ),
  liquidadaEl: txt(
    'Fecha de la liquidación final con el proveedor ("Pending" en el archivo = pendiente). En el archivo: Final Liquidation Intermediary/Exporter.',
    'Date of the final settlement with the supplier ("Pending" in the file = pending). In the file: Final Liquidation Intermediary/Exporter.',
  ),
  aceptadaEl: txt(
    'Cuándo se aceptó la liquidación. En el archivo: Liquidation Accepted Intermediary/Exporter.',
    'When the settlement was accepted. In the file: Liquidation Accepted Intermediary/Exporter.',
  ),
  pagoFinal: txt(
    'Fecha del pago final. En el archivo: FINAL PAYMENT DATE.',
    'Date of the final payment. In the file: FINAL PAYMENT DATE.',
  ),
  numeroContable: txt(
    'Número de la liquidación en el sistema contable (PBB, PAY, SPA…). En el archivo: LIQ PBB N.',
    'Settlement number in the accounting system (PBB, PAY, SPA…). In the file: LIQ PBB N.',
  ),
};
